module.exports = __webpack_public_path__ + "static/media/scca-runoffs@2x.25c838a3.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs@2x.png
// module id = 1164
// module chunks = 0